export const comments_5187255 = {"data":{"data":[],"links":{}}}